<template>
    <div class="log-page">
        <div>
            <el-timeline>
                <el-timeline-item v-for="log in changeLogs" v-bind:key="log.id" :timestamp="log.version + ' ( ' + log.time + ' )'" placement="top">
                    <el-card>
                        <div v-for="content in log.contents" v-bind:key="content.id">
                            <h4 class="change-type">{{content.type}}</h4>
                            <ul>
                                <li v-for="(item, index) in content.children" v-bind:key="index">{{item}}</li>
                            </ul>
                        </div>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>

<style lang="less" src="../styles/logPage.less" />

<script>
    import { defineComponent } from 'vue'
    import { ElTimeline, ElTimelineItem, ElCard } from 'element-plus'
    import changeLogs from '../assets/changeLogs'

    export default defineComponent({
        name: 'LogPage',
        components: {
            ElTimeline,
            ElTimelineItem,
            ElCard
        },
        data() {
            return {
                changeLogs
            };
        },
        methods: {
        },
    });
</script>
